<template>
  <QuesCard :maxwidth="maxwidth" :ques="ques" :showIsItemImg="true">
    <template slot="title">
      {{ ques.serial == null ? '' : ques.serial + '. ' }}多選題
    </template>

    <v-card-text class="text-start" slot="content">
      <div v-for="(name, idx) in ques.cnName.split(/\r?\n/)" :key="'A' + idx" class="blod quest_topic">
        {{ name }}
      </div>
      <div v-if="ques.questHeadingPic" class="text-center">
        <img
          v-bind:src="$store.state.server + ques.questHeadingPic"
          style="max-width: 100%;"
        />
      </div>

      <!-- 作答時的選項 -->
      <!-- ripple 需要設定為 fasle，否則會出現 v-ripple__container 類別的 spsn，造成點擊時大小改變 -->
      <!-- 選項為文字的情況 -->
      <template v-if="!ques.isItemImg">
        <!-- todo: 把 v-card 跟 checkbox 連動 -->
        <v-card
          class="px-3 mb-2"
          v-for="(opt, idx) in ques.items"
          :key="'B' + idx"
          :ripple="false"
        >
          <v-checkbox v-model="values[idx]" :label="opt" @change="chkOpt(idx)">
            <template slot="message"><div></div></template>
          </v-checkbox>
        </v-card>
      </template>
      <!-- 選項為圖片的情況 -->
      <template v-else>
        <v-card
          class="px-3 mb-2"
          v-for="(route, idx) in ques.fileRoutes"
          :key="'C' + idx"
          :ripple="false"
        >
          <v-checkbox v-model="values[idx]" @click="chkOpt(idx)">
            <template slot="label">
              <!-- <v-img :src="$store.state.server + route"></v-img> -->
              <img v-bind:src="$store.state.server + route" style="max-width:100%;"/>
            </template>
          </v-checkbox>
        </v-card>
      </template>
      <v-input
        :value="ques.value"
        :rules="[
          v => {
            let pass = !(ques.isRequired && (!ques.value || ques.value === ''))
            return pass ? true : '此題為必填，必須至少選出一個選項'
          }
        ]"
      >
      </v-input>
    </v-card-text>
  </QuesCard>
</template>

<script>
import QuesCard from './QuesCard'
export default {
  components: {
    QuesCard
  },
  props: {
    maxwidth: {
      type: Number,
      default: null
    },
    ques: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      values: []
    }
  },
  created() {    
    // window.console(this.ques.items)
    // this.values = this.ques.items.map(x => false)
    // window.console(this.values)
  },
  methods: {
    chkOpt(idx) {
      this.ques.value = this.values
        .map((x, idx) => (x === true ? idx : null))
        .filter(x => x !== null)
        .join('$')
      // [Debug]
      // window.console.log(this.ques.value)
    }
  }
}
</script>

<style lang="scss" scoped>

//題選項文字內容位置
.v-application .mb-2{
  display: flex;
  align-items: center;
}
.v-input--selection-controls{
  margin-top: 12px;
}
</style>
